<div class="ui-g-12">
    <p-toolbar>
        <div class="ui-toolbar-group-left">
            <button routerLink="/requests-management" pButton type="button" [label]='setLabel("goBackLabel")' icon="pi pi-arrow-left">
            </button>&nbsp;
            <button (click)="rejectRequest()" pButton type="button" [label]='setLabel("rejectLabel")' icon="pi pi-plus"
                class="ui-button-primary" style="background-color: #d81515;"
                *ngIf="requestor[0]?.requestStatus === 'Pending'">
            </button>&nbsp;
            <button (click)="freezeMember()" class="ui-button-info" pButton type="button" [label]='setLabel("approveLabel")'
                icon="fa fa-thermometer-empty" *ngIf="requestor[0]?.requestStatus === 'Pending'">
            </button>&nbsp;
            <!-- <button (click)="activateMember()" class="ui-button-primary" *ngIf="member.isDelete === true" pButton
                  type="button" label="Activate Member" icon="fa fa-times" style="background-color: #E91E63;"></button>&nbsp; -->
            <!-- <button (click)="defreezeMember(member)" pButton
                          type="button" label="DeFreeze Member" icon="fa fa-thermometer-empty" class="ui-button-primary"
                          style="background-color: #3F51B5;"></button>&nbsp; -->
        </div>
    </p-toolbar>
</div>
<div class="ui-g-12">
    <p-tabView>
        <p-tabPanel [header]='setLabel("freezeRequestHeaderLabel")'>
            <div class="card card-w-title">
                <div class="ui-g">
                    <div class="car-detail">
                        <img width="100%" height="195px"
                            [src]="requestor.profile == null ? 'assets/layout/images/avatarBoyImage.png' : requestor.profile" />
                    </div>
                    <div class="ui-g-2" style="text-align: center; align-self: flex-end;">
                        <p style="font-size: 20px;">{{setLabel("nameLabel")}}</p>
                    </div>
                    <div class="ui-g-3" style="align-self: flex-end; margin-bottom: 14px;">
                        <input type="text" disabled pInputText [(ngModel)]="request.name"
                            style="font-size: 35px; text-align: center; width: 240% !important;" />
                    </div>
                    <div class="ui-g-12">
                        <p-table [value]="requestor">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>{{setLabel("feeLabel")}}</th>
                                    <!-- <th>Freeze Date</th> -->
                                    <!-- <th>DeFreeze Date</th> -->
                                    <th>{{setLabel("startDateLabel")}}</th>
                                    <th>{{setLabel("endDateLabel")}}</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-req>
                                <tr>
                                    <td>{{req.monthFee}}</td>
                                    <td>{{req.freezeRequest.startFreezingDate | date: 'dd/MM/yyyy'}}</td>
                                    <td>{{req.freezeRequest.endFreezingDate | date: 'dd/MM/yyyy'}}</td>
                                    <!-- <td>{{freezreport.daysLeft}}</td> -->
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </p-tabPanel>
    </p-tabView>
</div>
